module.exports = __webpack_public_path__ + "img/luca.0943f828.svg";